import * as React from 'react';

import CollapseElem from 'Components/Collapse';

export const ConditionalCollapse = ({
  condition,
  children,
  rows,
}: {
  condition: boolean;
  children: React.JSX.Element;
  rows: string[];
}): React.JSX.Element =>
  condition ? (
    <CollapseElem localeIDs={{ showMessage: 'pulmonary.show', hideMessage: 'pulmonary.hide' }} amount={rows.length}>
      <div style={{ marginBottom: '1rem' }}>{children}</div>
    </CollapseElem>
  ) : (
    children
  );
